export type TopologyLinkPresentation = {
  topology_status?: string;
  topology_confidence?: number;
};

export const isUnconfirmedTopologyLink = (link: TopologyLinkPresentation) =>
  link.topology_status?.trim().toLowerCase() === 'likely' && link.topology_confidence === 90;
